import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import ModalExitAlert from "./modalExitAlert";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import addSoapNoteStyle from "../../styles/addSoapNoteStyle";

const SubmitButtonRef = React.createRef();

const TokenMapping = [
    {
        key: '<<PRE_NAME>>',
        target: 'PreName',
    },
    {
        key: '<<FIRST_NAME>>',
        target: 'FirstName',
    },
    {
        key: '<<LAST_NAME>>',
        target: 'LastName',
    },
    {
        key: '<<AGE>>',
        target: 'Age',
    },
    {
        key: '<<GENDER>>',
        target: 'Gender',
    },
    {
        key: '<<WEIGHT>>',
        target: 'Weight',
    },
    {
        key: '<<HEIGHT>>',
        target: 'Height',
    },
    {
        key: '<<BMI>>',
        target: 'BMI',
    }
];

class AddSoapNote extends React.Component {
    state = {
        orderNoteTextError: false,
        exitModalOpen: false,
        isChangeMade: false
    }

    componentDidMount() {
        const {
            productInfo = {},
            action: {
                getSoapTemplates = () => {},
            },
        } = this.props;
        const { productIds } = productInfo;

        // load soap note templates
        getSoapTemplates({ productIds });
    }

    handleSoapTemplateChange = ({ target: { value = -1 } }) => {
        const {
            selectedPatientInfo = {},
            soapNoteTemplates: {
                valuesCollection = new Map(),
            },
            action: {
                setSoapNote = () => {},
                setSoapTemplate = () => {},
            },
        } = this.props;
        setSoapTemplate({ value });

        if (valuesCollection.has(value)) {
            const template = valuesCollection.get(value);
            let note = template.TemplateText;

            for (let i = 0; i < TokenMapping.length; i++) {
                const { key, target } = TokenMapping[i];
                const regex = new RegExp(`(${key})`, 'gmi');
                note = note.replace(regex, selectedPatientInfo[target]);
            }
            setSoapNote({ name: 'orderNoteText', value: note });
        }
    }

    handleOrderNoteTextBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ orderNoteTextError: true })
        } else if (this.state.orderNoteTextError) {
            this.setState({ orderNoteTextError: false })
        }
    }

    UNSAFE_componentWillUnmount() {
        const {
            ClearAddNoteData = () => {},
            action: {
                setSoapTemplate = () => {},
            },
        } = this.props;
        this.setState({isChangeMade: false});
        ClearAddNoteData();
        setSoapTemplate({ value: -1 });
    }

    handleOrderNoteText = (e) => {
        if (!this.state.isChangeMade) {
            this.setState({isChangeMade: true})
        }
        let { SetAddSoapNoteValue } = this.props;
        SetAddSoapNoteValue && SetAddSoapNoteValue({ name: "orderNoteText", value: e.target.value })
    }

    componentDidUpdate() {
        if (this.state.orderNoteTextError && this.props.orderNoteText && this.props.orderNoteText.trim()) {
            this.setState({ orderNoteTextError: false })
        }
        if (this.props.isNoteAdded) {
            this.onConfirmation();
        }
    }


    onAddNoteButtonClick = (e) => {
        let { orderNoteText, AddSoapNote, selectedCardData = {}, productInfo } = this.props;
        let data = {
            "OrderId": productInfo.OrderId,
            "PatientId": selectedCardData.UserId,
            "NoteText": orderNoteText,
        };
        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        AddSoapNote && AddSoapNote(data);
        this.props.enableOnSoapSuccess();
    }

    handleCheckClick = (e) => {
        if (!this.state.isChangeMade) {
            this.setState({isChangeMade: true})
        }
        let { SetAddSoapNoteValue, addPatientNote } = this.props;
        addPatientNote = !addPatientNote;
        SetAddSoapNoteValue && SetAddSoapNoteValue({ name: "addPatientNote", value: addPatientNote })
    }

    openAlertModal = () => {
        let { closeOpenAddNote } = this.props;
        if (!this.state.isChangeMade) {
            closeOpenAddNote && closeOpenAddNote();
        } else {
            this.setState({ exitModalOpen: true });
        }
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        let { closeOpenAddNote, ClearAddNoteData } = this.props;
        this.setState({ exitModalOpen: false });
        ClearAddNoteData && ClearAddNoteData();
        closeOpenAddNote && closeOpenAddNote();
    }

    render() {
        let { openSoapNote, classes, orderNoteText, isModalAlertOpen, SetModalAlertOpen, soapNoteTemplates = {} } = this.props;

        return (
            <CommonModalV2 title="Add SOAP Note" open={openSoapNote} style={{ width: modalWidth.l }}>
                <div data-view="add-note-component-wrapper" className={classes.modalBody}>
                    {
                        process.env.REACT_APP_SHOW_SOAP_NOTE_TEMPLATE_LISTING === 'true' && (
                            <div className='flex flex.align-items-center m-b-2'>
                                <div className={classes.orderNote}>SOAP TEMPLATES:</div>
                                <FormControl variant="outlined" className={classes.productInput}>
                                    <Select
                                        labelId="customized-select-label"
                                        id="selected-email-patient"
                                        MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                        classes={{ outlined: classes.productSelectStyle }}
                                        value={soapNoteTemplates.value}
                                        onChange={this.handleSoapTemplateChange}
                                        label={void 0}
                                    >
                                        <MenuItem
                                            title={"-- Choose --"}
                                            classes={{ selected: classes.menuItemSelected }}
                                            className={classes.menuItemRoot}
                                            value={-1}>
                                            -- Choose --
                                        </MenuItem>
                                        {soapNoteTemplates.api.data.map(({ Id, TemplateTitle }) => {
                                            return <MenuItem
                                                title={TemplateTitle}
                                                classes={{ selected: classes.menuItemSelected }}
                                                className={classes.menuItemRoot}
                                                key={Id}
                                                value={Id}>
                                                {TemplateTitle}
                                            </MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        )
                    }
                    <div className={classes.contentWrapperNoAlign}>
                        <div className={classes.orderNote}>ORDER NOTE:</div>
                        <textarea
                            maxLength={4000}
                            spellCheck={true}
                            name={"orderNoteText"}
                            id="orderNoteText"
                            onBlur={this.handleOrderNoteTextBlur}
                            value={orderNoteText}
                            onChange={this.handleOrderNoteText}
                            className={this.state.orderNoteTextError ? classes.textAreaOrderNoteError : classes.textAreaOrderNote}
                        />
                    </div>
                    {/* <div className={classes.contentWrapper}>
                        <div className={classes.orderNoteCheckBox}></div>
                        <Checkbox
                            title=""
                            checked={addPatientNote}
                            id="add-patient-note-check"
                            className={addPatientNote ? classes.checkbox : classes.disabledCheckbox}
                            onChange={this.handleCheckClick}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                        <div className={classes.checkboxText} onClick={this.handleCheckClick}>Also add this as a Patient Note</div>
                    </div> */}
                    <div className={classes.modalActionWrapper}>
                        <Button
                            disabled={
                                (!orderNoteText) || (orderNoteText && orderNoteText.trim() === "")
                            }
                            ref={SubmitButtonRef}
                            onClick={this.onAddNoteButtonClick}
                            id="addNoteSubmitBtn"
                            variant="contained" color="primary"
                            className={classes.buttonStyle}>
                            Add Note
                        </Button>
                        <Button
                            onClick={this.openAlertModal}
                            variant="contained"
                            color="primary"
                            id="addNoteCancelBtn"
                            className={classes.cancelButtonStyle}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.isChangeMade && this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
            </CommonModalV2>
        );
    }
}


export default withStyles(addSoapNoteStyle)(AddSoapNote);

